export default __webpack_public_path__ + "014a573c73ba09be55457bbd5f95b9dc.png";